import React, { useEffect, useState } from 'react'
import { GlobalContext } from "../../Context/Context"
import { getBaseUrl } from "../../Services/HttpService"
const LeftAddComponent = () => {
    const context = React.useContext(GlobalContext)
    let adds = context.common.adds
    const [addUrl, setAddUrl] = useState(null)
    const [addLink, setAddLink] = useState(null)
    let TimerFunction = null
    useEffect(() => {
        let leftArray = adds.filter(add => (add.AdPosition === "left" && add.AdStatus === "Active"));
        if (leftArray.length) {
            setAddUrl(getBaseUrl() + "/advertisementfiles/" + leftArray[0].AdImageVideo)
            setAddLink(leftArray[0].AdLink)
            setAdd()
        }
      
    }, [])
    const setAdd = () => {
        const chooseAdd = () => {
         
            let leftArray = adds.filter(add => (add.AdPosition === "left" && add.AdStatus === "Active"));
            const random = Math.floor(Math.random() * leftArray.length);
            setAddUrl(getBaseUrl() + "/advertisementfiles/" + leftArray[random].AdImageVideo)
            setAddLink(leftArray[random].AdLink)
        }
        TimerFunction = setInterval(chooseAdd, 5000);
        return (() => {
            clearInterval(TimerFunction);
        })
    }
    return (<div className="Adv_box mb-2">
        <a href={addLink} target="_blank">
            <img
                src={addUrl}
                alt="adv" />
        </a>
    </div>)
}
export default LeftAddComponent